import React from 'react'
import vid from '../../Assets/logo.png'
import { Container, Row, Col } from "react-bootstrap";

import { Link } from 'react-router-dom';
import {Card} from 'react-bootstrap';
import {Button } from 'react-bootstrap'
import i1 from '../../Assets/i1.png'
import i2 from '../../Assets/i2.png'

function Logo() {
  return (
    <div>
     <Container fluid className="home-about-section " id="about">
     
     <Container>
      <h1 className="heading-name">
            <strong className="main-name">Logo Design</strong>
      </h1>
      <div style={{ display: 'flex-right',float:'right'}}>
       <Link to='/serviceform'> <Button >Order Now</Button></Link>
        </div>
    <div style={{ paddingTop:'50px' }}>
   
      <h1 className='white-text' style={{ justifyContent: "center"}}>
        ሎጎ ዲዛይን We use floats property to right-shift a container with respect to its parent container. 
      </h1>
 
  
    </div>

      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={1} md={3} className="tech-icons">
     <img src={i2}/>
     <h1 className="white">Technology</h1>
      </Col>
      <Col xs={1} md={3} className="tech-icons">
     <img src={i1}/>
     <h1 className="white">Clothing Brand</h1>
      </Col> <Col xs={1} md={3} className="tech-icons">
     <img src={vid}/>
      </Col>
      <Col xs={4} md={3} className="tech-icons">
     <img src={vid}/>
     <h1 className="white">Cafe</h1>
      </Col>
     
  
      
      </Row>
      <p className='white-text' style={{ justifyContent: "center" , align:'justify'}}>
        We use float property to right-shift a container with respect to its parent container. 
        We apply this property to the parent container to right and all the child elements inside the container will align to the right of the container. This approach is useful when you want to align a group of elements to the right side of a container or web page.
       </p>
      </Container>
    </Container>

    </div>
  )
}

export default Logo
